import Swiper, { Navigation, Pagination, Autoplay, EffectFade, Lazy } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Lazy]);
export default class Carousel {
    constructor() {
        this.defaultConfig = {
            direction: 'horizontal',
            watchOverflow: true,
            centeredSlides: true,
            grabCursor: true,
            fadeEffect: { crossFade: true },
            autoplay: {
                delay: 5000,
            },
            loop: true,
            lazy: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            // And if we need scrollbar
            scrollbar: {
                el: '.swiper-scrollbar',
            }
        };
        document.addEventListener('DOMContentLoaded', () => { this.init(); });
    }
    init() {
        this.initSwiper();
    }
    initSwiper() {
        var initVideoPlayers = (swiper) => {
            const players = Array.from(swiper.el.querySelectorAll("video"));
            players.forEach((player) => {
                player.addEventListener('playing', () => {
                    swiper.autoplay.stop();
                });
                player.addEventListener('ended', () => {
                    console.log("ENDED");
                    swiper.autoplay.start();
                    swiper.slideNext();
                });
            });
        };
        var setVideoPlayer = async (swiper) => {
            var slides = swiper.el.querySelector(".swiper-slide");
            const players = Array.from(swiper.el.querySelectorAll(".swiper-slide video"));
            players.forEach((player) => {
                var isPlaying = player.currentTime > 0 && !player.paused && !player.ended && player.readyState > player.HAVE_CURRENT_DATA;
                if (isPlaying) {
                    player.pause();
                }
            });
            const activeSlide = swiper.el.querySelectorAll(".swiper-slide-active");
            const videoPlayer = swiper.el.querySelector(".swiper-slide-active video");
            if (videoPlayer) {
                videoPlayer.currentTime = 0.01;
                videoPlayer.muted = true;
                await videoPlayer.play();
            }
        };
        let heroSwipers = document.querySelectorAll('.hero-swiper, .content-swiper');
        if (heroSwipers.length > 0) {
            for (var i = 0; i < heroSwipers.length; i++) {
                var hero = heroSwipers[i];
                var slides = hero.querySelectorAll('.swiper-slide');
                if (slides.length > 1) {
                    let configAttributes = hero.getAttribute("swiper-config");
                    let config = configAttributes ? JSON.parse(configAttributes) : {};
                    let swiperConfig = {};
                    Object.assign(swiperConfig, this.defaultConfig);
                    Object.assign(swiperConfig, config);
                    swiperConfig["on"] = {
                        "init": function (s) {
                            initVideoPlayers(s);
                            setVideoPlayer(s);
                        },
                        "slideChangeTransitionEnd": async function (s) {
                            setVideoPlayer(s);
                        }
                    };
                    var pagination = hero.parentElement.querySelector(".swiper-pagination");
                    if (pagination) {
                        swiperConfig["pagination"] = {
                            el: pagination,
                            clickable: true,
                        };
                    }
                    var nextButton = hero.parentElement.querySelector(".swiper-button-next");
                    var prevButton = hero.parentElement.querySelector(".swiper-button-prev");
                    if (nextButton && prevButton) {
                        swiperConfig["navigation"] = {
                            nextEl: nextButton,
                            prevEl: prevButton,
                        };
                    }
                    let mySwiper = new Swiper(hero, swiperConfig);
                }
            }
        }
        let timeline = document.querySelectorAll(".timeline.timeline-horizontal .swiper-container");
        if (timeline.length > 0) {
            for (let i = 0; i < timeline.length; i++) {
                let item = timeline[i];
                let s = new Swiper(item, {
                    direction: 'horizontal',
                    watchOverflow: true,
                    centeredSlides: true,
                    grabCursor: true,
                    fadeEffect: { crossFade: true },
                    autoplay: false,
                    loop: true,
                    lazy: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                        renderBullet: function (index, className) {
                            return '<div class="' + className + '">' + (index + 1) + '</div>';
                        },
                    },
                });
            }
            ;
        }
    }
}
